import React from 'react';
import Cookies from 'universal-cookie';

const TheDMSEffectLogo = '/images/DMS-Login-Logo.png';
const cookies = new Cookies();

export default class ErrorBoundaryFallback extends React.Component {
    state = {
        status: 'Something went wrong',
    }

    componentDidMount() {
        if (!this.props.notFound && cookies.get('error_response')) {
            this.setState({ status: cookies.get('error_response') })
        }
    }

    removeCookies = () => {
        cookies.remove('access_token');
        cookies.remove('refresh_token');
        cookies.remove('isAdUser');
        cookies.remove('license_expired');
        cookies.remove('isAzureUser');
        cookies.remove('samlLogin')
        cookies.remove('error_response');
    };

    // This component is rendered both as the `/error-page` route element and as
    // the `FallbackComponent` of the two `react-error-boundary` boundaries.
    // Neither role passes a `history` prop, so the previous
    // `this.props.history.goBack()` always threw. The anchor's `href` performs
    // the navigation; this only has to clear the stale status cookie first.
    reload = () => {
        cookies.remove('error_response');
    }

    render() {
        const notFound = this.props.notFound;

        return (
            <main className="system-message-page">
                <div className="system-message-card">
                    <img src={TheDMSEffectLogo} className="system-message-logo" alt="theDMSeffect" />
                    <h1>{notFound ? 'Page not found' : this.state.status}</h1>
                    <p>{notFound
                        ? 'We could not find that page. Check the address or return to the dashboard.'
                        : 'Please try the dashboard again. If the problem continues, contact support.'}</p>
                    <div className="system-message-actions">
                        <a href="/" onClick={this.reload}>Go to dashboard</a>
                        <a href="/login" onClick={this.removeCookies}>Back to login</a>
                    </div>
                    <p className="system-message-support">
                        Need help? Call <a href="tel:+61240549600">02 4054 9600</a> or email{' '}
                        <a href="mailto:support@theDMSeffect.com.au">support@theDMSeffect.com.au</a>.
                    </p>
                </div>
            </main>
        );
    }
}
